import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import EditableHtml from '@pie-lib/editable-html-tip-tap';
import { stripHtmlTags } from './markupUtils';

const findSlateNode = (key) => {
  return window.document.querySelector('[data-key="' + key + '"]');
};

const StyledEditableHtml = styled(EditableHtml)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  outline: 'none',
  lineHeight: '15px',
}));

export class ECRToolbar extends React.Component {
  static propTypes = {
    correctChoice: PropTypes.object,
    node: PropTypes.object,
    pos: PropTypes.number,
    onDone: PropTypes.func,
    onChangeResponse: PropTypes.func.isRequired,
    onToolbarDone: PropTypes.func.isRequired,
    value: PropTypes.shape({
      change: PropTypes.func.isRequired,
      document: PropTypes.shape({
        getNextText: PropTypes.func.isRequired,
      }),
    }),
    editor: PropTypes.object,
    maxLengthPerChoiceEnabled: PropTypes.bool,
    pluginProps: PropTypes.object,
    spellCheck: PropTypes.bool,
  };

  state = {
    markup: '',
    toolbarStyle: {},
  };

  componentDidMount() {
    const { correctChoice, node, editor } = this.props;
    const choice = correctChoice || {};

    const domNode = editor.view.nodeDOM(editor.state.selection.from);

    if (domNode?.nodeType === 1) {
      //eslint-disable-next-line
      const domNodeRect = domNode.getBoundingClientRect();
      const editor = domNode.closest('.tiptap');
      const editorRect = editor.getBoundingClientRect();
      const top = domNodeRect.top - editorRect.top;
      const left = domNodeRect.left - editorRect.left;

      this.setState({
        markup: choice.label,
        toolbarStyle: {
          position: 'absolute',
          // top: `${top + domNodeRect.height + 17}px`,
          top: 0,
          // left: `${left + 20}px`,
          left: 0,
          width: `${domNodeRect.width - 4}px`,
        },
      });
    }
  }

  onDone = (markup) => {
    const { editor, node, onToolbarDone, onChangeResponse, pos } = this.props;
    const sanitizedMarkup = stripHtmlTags(markup);
    this.setState({ markup: sanitizedMarkup });

    const { tr } = editor.state;

    // Type check before calling setNodeMarkup: if the node at the current position is a text node,
    // missing, or not an inline atom, bail out to avoid errors after a delete.
    const nodeAtPos = tr.doc.nodeAt(pos);
    if (!nodeAtPos || nodeAtPos.isText || !nodeAtPos.isAtom || !nodeAtPos.isInline) {
      return false;
    }

    // Merge old and new attributes
    tr.setNodeMarkup(pos, undefined, { ...node.attrs, value: sanitizedMarkup });
    editor.view.dispatch(tr);

    onToolbarDone(true);
    onChangeResponse(sanitizedMarkup);
  };

  onRespAreaChange = (respAreaMarkup) => {
    this.setState({ respAreaMarkup });
  };

  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      return true;
    }

    return false;
  };

  onBlur = () => {
    if (this.clickedInside) {
      this.clickedInside = false;
    }
  };

  render() {
    const { maxLengthPerChoiceEnabled, pluginProps, spellCheck } = this.props;
    const { markup, toolbarStyle } = this.state;
    const inputProps = maxLengthPerChoiceEnabled ? {} : { maxLength: 25 };

    return (
      <div style={toolbarStyle}>
        <StyledEditableHtml
          autoFocus={true}
          disableUnderline
          onChange={(respAreaMarkup) => {
            if (this.preventDone) {
              return;
            }
            this.onRespAreaChange(respAreaMarkup);
          }}
          onDone={(val) => {
            if (this.preventDone) {
              return;
            }
            this.onDone(val);
          }}
          onBlur={(e) => {
            this.preventDone = e.relatedTarget && e.relatedTarget.closest('.insert-character-dialog');
            this.onBlur(e);
          }}
          onKeyDown={this.onKeyDown}
          markup={markup || ''}
          activePlugins={['languageCharacters']}
          pluginProps={pluginProps}
          languageCharactersProps={[{ language: 'spanish' }]}
          minHeight={'15px'}
          maxHeight={'15px'}
          spellCheck={spellCheck}
          autoWidthToolbar
          toolbarOpts={{
            minWidth: 'auto',
            isHidden: !!pluginProps?.characters?.disabled,
          }}
          {...inputProps}
        />
      </div>
    );
  }
}

export default ECRToolbar;
